var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"statement-react"},[_c('jybe-nonauth-button',{attrs:{"statement":_vm.statement}}),_c('login-button',{attrs:{"text":'Login to react'}}),_c('share-button',{attrs:{"type":'statements',"id":_vm.statement.id}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }